module.exports = __webpack_public_path__ + "static/media/tasteEnvelope.6932eb4d.jpg";